export const handlePhoneNumberAutocomplete = (phoneNumber: string): string => {
  const phoneCopy = phoneNumber.slice().replace('+', '');
  const countryCodes = ['54', '55', '1', '56', '57', '52', '51', '58'];
  const hasCountryCode = countryCodes.some((code) =>
    phoneCopy.startsWith(code)
  );

  return hasCountryCode ? `+${phoneCopy}` : `+52${phoneCopy}`;
};
